var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"dir":_vm.d12n.direction}},[_c('navigation'),_c('p',[_vm._v(" "+_vm._s(_vm.d12n.introduction)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }